import React from 'react';
import './ChatMenuInterface.css';
import logger from '../../../../../../utils/logger';

const ChatMenuInterface = ({ 
  menuItems = [], 
  onMenuItemClick, 
  botMessageBoxColor, 
  botMessageTextColor,
  userMessageBoxColor, 
  userMessageTextColor,
  chatbotId,
  isPlatform,
  isSlashTriggered = false
}) => {
  
  // Debug the color values
  logger.log('ChatMenuInterface colors:', {
    botMessageBoxColor,
    userMessageBoxColor,
    botMessageTextColor
  });

  const handleMenuItemClick = (menuItem) => {
    if (menuItem.type === 'FAQ' && menuItem.action) {
      // Create a user message indicating which menu item was selected
      const userMessage = { role: 'user', content: menuItem.name };
      // Create the FAQ response message
      const assistantMessage = { role: 'assistant', content: menuItem.action };
      
      // Track menu item usage in analytics (only for non-platform/embed usage and if tracking is loaded)
      if (!isPlatform && typeof window !== 'undefined') {
        // Track in Clarity (only if loaded and available)
        if (window.clarity) {
          window.clarity('set', 'menu_item_clicked', menuItem.name);
          window.clarity('set', 'chatbot_id', chatbotId);
        }
      }
      
      // Call the parent callback with both messages and delay flag
      if (onMenuItemClick) {
        onMenuItemClick(userMessage, assistantMessage, menuItem, true); // true indicates menu response needs delay
      }
    }
    // Note: Script type handling can be implemented later
  };

  if (!menuItems || menuItems.length === 0) {
    return null;
  }

  return (
    <div className="chatbot-menu-interface">
      <div className="menu-header">
        <p>
          {isSlashTriggered ? "Type or choose from the options below" : "Type or choose from the options below"}
        </p>
      </div>
      
      <div 
        className="menu-container"
        style={{
            backgroundColor: userMessageBoxColor,
            color: userMessageTextColor,
            borderColor: userMessageBoxColor
          }}
      >
        <div className="menu-list">
          {menuItems.filter((item) => item.type !== 'Script').map((item, index) => (
            <div
              key={item.id || index}
              className={`menu-list-item ${item.type.toLowerCase()} ${item.type === 'Script' ? 'disabled' : ''}`}
              onClick={() => item.type !== 'Script' && handleMenuItemClick(item)}
              style={{
                backgroundColor: botMessageBoxColor,
                borderBottomColor: 'rgba(255, 255, 255, 0.15)'
              }}
            >
              {/* <div className="menu-item-icon">
                {item.type === 'FAQ' ? '💬' : '⚡'}
              </div> */}
              <div className="menu-item-content">
                <span 
                  className="menu-item-name"
                  style={{ 
                    color: botMessageTextColor,
                  }}
                >
                  {item.name}
                </span>
                {/* TODO: Restore Script menu items after the feature is ready. */}
              </div>
              <div className="menu-item-arrow"
              style={{
                    color: botMessageTextColor,
                    borderColor: botMessageBoxColor
                }}>
                {item.type !== 'Script' && '›'}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChatMenuInterface;
